import { createFileRoute, redirect } from '@tanstack/react-router';

import { StoreSelectionStep } from '@apple/features/cart-retail/components/steps/stores';

export const Route = createFileRoute('/_authed/cart/_steps/stores')({
	beforeLoad: ({
		context: {
			auth: { canAccessMultipleStores },
		},
	}) => {
		if (!canAccessMultipleStores) {
			throw redirect({
				to: '/cart/products',
				replace: true,
			});
		}
	},
	component: RouteComponent,
	wrapInSuspense: true,
});

function RouteComponent() {
	return <StoreSelectionStep />;
}
